export enum AssistantType {
  DEFAULT = "default",
  VISUALIZE = "visualize",
}
